import { SuggestionData } from '../Suggestions/types';
import { FilterChoice } from '../types/FilterChoice';
import { LocationChoice } from '../types/LocationChoice';

export const generateSuggestionData = (filters: FilterChoice, location?: LocationChoice) => {
  const suggestion: SuggestionData = {
    id: `specialtyValue-${location?.suburb?.postcode ?? filters.location?.suburb?.postcode}-${
      location?.suburb?.name ?? filters.location?.suburb?.name
    }`,
    type: 'FilterSuggestion',
    filters: { ...filters, location: location },
  };

  return suggestion;
};
